var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"sm":"2","md":"2"}},[_c('v-card',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","border-radius":"10px","border":"1px solid grey","min-height":"160px","width":"120px"},attrs:{"to":{
       name: 'Edit',
       query: {
         source: 'template',
         chart_id: _vm.card.chart_id,
       },
     },"flat":""}},[_c('v-img',{staticClass:"mx-5 mt-5",staticStyle:{"max-height":"60px"},attrs:{"contain":"","src":_vm.card.img}}),_c('v-card-text',{staticClass:"text-h8 mb-0 mt-0 font-weight-bold text-center"},[_vm._v(" "+_vm._s(_vm.card.button)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }